import { c as _c } from "react/compiler-runtime";
import styles from "../shared.module.css";
interface AuthButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  type?: "button" | "submit";
}
export function AuthButton(t0) {
  const $ = _c(6);
  const {
    children,
    onClick,
    disabled,
    loading,
    type: t1
  } = t0;
  const type = t1 === undefined ? "button" : t1;
  const t2 = `${styles.authButton} ${loading ? styles.authButtonLoading : ""}`;
  const t3 = disabled || loading;
  let t4;
  if ($[0] !== children || $[1] !== onClick || $[2] !== t2 || $[3] !== t3 || $[4] !== type) {
    t4 = <button type={type} className={t2} onClick={onClick} disabled={t3}>{children}</button>;
    $[0] = children;
    $[1] = onClick;
    $[2] = t2;
    $[3] = t3;
    $[4] = type;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}